import { Tag } from 'antd'

const NewTag = () => (
  <Tag style={{ backgroundColor: '#40c1b9', color: '#ffffff', fontWeight: 'bold', border: 'none', fontSize: '12px' }}>
    {'NEW'}
  </Tag>
)

export default NewTag
